import "core-js/modules/es.parse-int";
import { FormattedMessage, FormattedRelative } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { StarRating } from '../StarRating/StarRating';
export var Review = function Review(_ref) {
  var createdOn = _ref.createdOn,
      nameOfClass = _ref.nameOfClass,
      studioResponse = _ref.studioResponse,
      teacherName = _ref.teacherName,
      rating = _ref.rating,
      review = _ref.review;
  return React.createElement("div", {
    className: "review__single"
  }, React.createElement("time", null, React.createElement(FormattedRelative, {
    value: createdOn
  })), rating && React.createElement(StarRating, {
    rating: parseInt(rating, 10),
    className: "mb-"
  }), React.createElement("h5", null, teacherName ? React.createElement(FormattedMessage, {
    id: "review.title",
    defaultMessage: "{nameOfClass} with {teacherName}",
    values: {
      nameOfClass: nameOfClass,
      teacherName: teacherName
    }
  }) : React.createElement(FormattedMessage, {
    id: "review.title-no-teacher",
    defaultMessage: "{nameOfClass}",
    values: {
      nameOfClass: nameOfClass
    }
  })), React.createElement("div", null, review), studioResponse && React.createElement("div", {
    className: "review__single__response"
  }, React.createElement(FormattedMessage, {
    tagName: "strong",
    id: "review.response.title",
    defaultMessage: "Response from the studio:"
  }), React.createElement("div", {
    className: "text--light"
  }, studioResponse)));
};
Review.propTypes = {
  createdOn: PropTypes.object.isRequired,
  nameOfClass: PropTypes.string.isRequired,
  studioResponse: PropTypes.string,
  teacherName: PropTypes.string,
  rating: PropTypes.number,
  review: PropTypes.string.isRequired
};